/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import '../../assets/stylesheets/Acordion.css';



export default function Acordion({children = <></>, title = '', open = false, customHeader = <></>, noAfter = false}) {
  const handleChange = (e) => {
    const { target:acordionHeader } = e
    const acordionBody = acordionHeader.nextElementSibling;

    acordionHeader.classList.toggle('acordion__header--active');
    acordionBody.classList.toggle('acordion__body--expand');

  }

  return (<>
    <div className="acordion">
      <div
        className={`acordion__header ${noAfter && 'no_after'} ${ open && 'acordion__header--active' }`}
        onClick={handleChange}
        data-toggle={'tooltip'}
        title={'Ver calificaciones'}
      >
        <h4>{title || ''}</h4>
        {customHeader}
      </div>
      <div
        className={`acordion__body ${ open && 'acordion__body--expand' }`}
      >
        {children}
      </div>
    </div>
  </>)
}